export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5948.b00aa4b5.jpg";